

const gameDifficultyConverter = (difficulty) => {
  const difficultyLevels = ['low', 'medium', 'high'];
  if (!difficultyLevels.includes(difficulty)) {
    throw new Error('Invalid difficulty level');
  }
  switch (difficulty) {
    case 'low':
      return 1;
    case 'medium':
      return 2;
    case 'high':
      return 3;
    default:
      return 2;
  }
}
export default gameDifficultyConverter;
